import { render, staticRenderFns } from "./basicDataSummaryPk.vue?vue&type=template&id=23eb3dab&"
import script from "./basicDataSummaryPk.vue?vue&type=script&lang=js&"
export * from "./basicDataSummaryPk.vue?vue&type=script&lang=js&"
import style0 from "./basicDataSummaryPk.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports